import { TOOLS } from '@/tools/registry'
import type { SectionOf } from './shared'

/**
 * The tools whose own copy exists in Turkish. Everything else in `TOOLS` is
 * English in every locale, which the `tool` case below has to say out loud.
 */
const TURKISH_TOOLS = new Set(['transformation-readiness'])

export default function ToolSection({ section }: { section: SectionOf<'tool'> }) {
  const Tool = TOOLS[section.tool]
  if (!Tool) return null
  // The Guts Check and the Index have no Turkish copy — there is a `check:`
  // note on both pages saying so — so on /tr they render English words
  // inside a `lang="tr"` document. That costs more than screen-reader
  // pronunciation: CSS `text-transform: uppercase` follows the document's
  // language, and Turkish maps `i` to `İ`, so every uppercase label inside
  // them came out "A DEFİNED UNİT OF VALUE". Naming the language of the
  // region is the fix. Delete the wrapper for a tool the day its Turkish
  // is written — the Diagnostic came bilingual and is already out.
  return TURKISH_TOOLS.has(section.tool) ? (
    <Tool />
  ) : (
    <div lang="en">
      <Tool />
    </div>
  )
}
